import { JsonBodyRemarkPlugin } from './markdown-plugins-utils.js';
import { PinoutTableMarkdownItem } from './pinout-table-markdown-item.js';

import type { RemarkMarkdownDirectiveDefinition } from './markdown-plugins-utils.js';

/** Directive name used in markdown: `:::pinout-table` */
export const PINOUT_TABLE_DIRECTIVE = 'pinout-table';

/**
 * Remark plugin definition for the `pinout-table` container directive.
 *
 * The directive body must be a JSON array of signal-to-pins mappings; the raw JSON string is
 * passed to {@link PinoutTableMarkdownItem} via the `jsonData` prop.
 *
 * Usage in markdown:
 * ```
 * :::pinout-table
 * [{"signalName":"CLK","pins":["A1","B2"]}]
 * :::
 * ```
 */
export const pinoutTableDirectiveDefinition: RemarkMarkdownDirectiveDefinition = {
	allowedAttributes: ['jsonData'],
	directive: JsonBodyRemarkPlugin(PINOUT_TABLE_DIRECTIVE),
	item: PinoutTableMarkdownItem,
};
